export default __webpack_public_path__ + "static/spin-the-wheel-ff13e677ae4f301ea3de77c39adf9608.png";